import { Injectable } from '@angular/core';
import { DayJsDatetimeAdapterCalendarNames, DayJsDatetimeAdapterTranslations } from '@improver/components/dayjs-datetime';
import { BehaviorSubject } from 'rxjs';
import { Translatable } from './translation.model';

@Injectable()
export class TranslationAdapter implements DayJsDatetimeAdapterTranslations {
  translations = new BehaviorSubject<DayJsDatetimeAdapterCalendarNames>(null);

  onTranslationLoaded(data: Translatable) {
    this.translations.next(this.filterCalendarTranslations(data));
  }

  private filterCalendarTranslations(translations: Translatable): DayJsDatetimeAdapterCalendarNames {
    return {
      monthNames: {
        long: [
          translations['APP_MONTHS_NAMES_LONG_JANUARY'],
          translations['APP_MONTHS_NAMES_LONG_FEBRUARY'],
          translations['APP_MONTHS_NAMES_LONG_MARCH'],
          translations['APP_MONTHS_NAMES_LONG_APRIL'],
          translations['APP_MONTHS_NAMES_LONG_MAY'],
          translations['APP_MONTHS_NAMES_LONG_JUNE'],
          translations['APP_MONTHS_NAMES_LONG_JULY'],
          translations['APP_MONTHS_NAMES_LONG_AUGUST'],
          translations['APP_MONTHS_NAMES_LONG_SEPTEMBER'],
          translations['APP_MONTHS_NAMES_LONG_OCTOBER'],
          translations['APP_MONTHS_NAMES_LONG_NOVEMBER'],
          translations['APP_MONTHS_NAMES_LONG_DECEMBER'],
        ],
        short: [
          translations['APP_MONTHS_NAMES_SHORT_JANUARY'],
          translations['APP_MONTHS_NAMES_SHORT_FEBRUARY'],
          translations['APP_MONTHS_NAMES_SHORT_MARCH'],
          translations['APP_MONTHS_NAMES_SHORT_APRIL'],
          translations['APP_MONTHS_NAMES_SHORT_MAY'],
          translations['APP_MONTHS_NAMES_SHORT_JUNE'],
          translations['APP_MONTHS_NAMES_SHORT_JULY'],
          translations['APP_MONTHS_NAMES_SHORT_AUGUST'],
          translations['APP_MONTHS_NAMES_SHORT_SEPTEMBER'],
          translations['APP_MONTHS_NAMES_SHORT_OCTOBER'],
          translations['APP_MONTHS_NAMES_SHORT_NOVEMBER'],
          translations['APP_MONTHS_NAMES_SHORT_DECEMBER'],
        ],
        narrow: [],
      },
      dayOfWeekNames: {
        long: [
          translations['APP_DAY_OF_WEEK_NAMES_LONG_SUNDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_LONG_MONDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_LONG_TUESDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_LONG_WEDNESDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_LONG_THURSDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_LONG_FRIDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_LONG_SATURDAY'],
        ],
        short: [
          translations['APP_DAY_OF_WEEK_NAMES_SHORT_SUNDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_SHORT_MONDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_SHORT_TUESDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_SHORT_WEDNESDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_SHORT_THURSDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_SHORT_FRIDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_SHORT_SATURDAY'],
        ],
        narrow: [
          translations['APP_DAY_OF_WEEK_NAMES_NARROW_SUNDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_NARROW_MONDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_NARROW_TUESDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_NARROW_WEDNESDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_NARROW_THURSDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_NARROW_FRIDAY'],
          translations['APP_DAY_OF_WEEK_NAMES_NARROW_SATURDAY'],
        ],
      },
    };
  }
}
